const formGroupHelpTextStyles = "@layer crnt.form-group-help {\n\t@layer base {\n\t\t:host,\n\t\t.crnt-form-group-help-text {\n\t\t\tdisplay: inline-block;\n\t\t\tfont: var(--crnt-sem-typography-sm-regular);\n\t\t\tcolor: var(--crnt-comp-help-text-color-fg-default);\n\t\t}\n\t}\n}\n";

export { formGroupHelpTextStyles as default };
